import React, { useState } from "react";
import "./Buscador.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";
import { useHistory } from "react-router-dom/cjs/react-router-dom";

function Buscador() {
  const history = useHistory();
  const [searchValue, setSearchValue] = useState("");

  return (
    <>
      <div className="BuscadorContainer">
        <div className="flexBuscador">
          <img
            src="./Images/Picsart_23-07-15_00-03-20-307.png"
            className="WrapImgBuscador"
          ></img>
          <h3 className="VerCatalogo" onClick={() => history.push("/catalogo")}>
            VER CATÁLOGO
          </h3>

          <div class="containerSearcher">
            <form className="inline" action="">
              <button
                type="submit"
                onClick={() => {
                  history.push("/catalogo?search=" + searchValue);
                }}
                className="SubmitBuscar"
              >
                <FontAwesomeIcon
                  icon={faMagnifyingGlass}
                  style={{ color: "#000000" }}
                />
              </button>
              <input
                type="text"
                name=""
                onChange={(e) => setSearchValue(e.target.value)}
                className="InputBuscar"
                placeholder="BUSCAR PRODUCTO"
              />
            </form>
          </div>
        </div>
      </div>
    </>
  );
}
export default Buscador;
